import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bdf8a514")

_pushScopeId("data-v-bdf8a514")
const _hoisted_1 = { class: "color-picker" }
const _hoisted_2 = { class: "picker-saturation-wrap" }
const _hoisted_3 = { class: "picker-controls" }
const _hoisted_4 = { class: "picker-color-wrap" }
const _hoisted_5 = { class: "picker-sliders" }
const _hoisted_6 = { class: "picker-hue-wrap" }
const _hoisted_7 = { class: "picker-alpha-wrap" }
const _hoisted_8 = { class: "picker-field" }
const _hoisted_9 = { class: "picker-presets" }
const _hoisted_10 = { class: "picker-gradient-presets" }
const _hoisted_11 = { class: "picker-presets" }
const _hoisted_12 = {
  key: 0,
  class: "recent-colors-title"
}
const _hoisted_13 = { class: "recent-colors" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Saturation = _resolveComponent("Saturation")
  const _component_Checkboard = _resolveComponent("Checkboard")
  const _component_Hue = _resolveComponent("Hue")
  const _component_Alpha = _resolveComponent("Alpha")
  const _component_EditableInput = _resolveComponent("EditableInput")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Saturation, {
        value: _ctx.color,
        hue: _ctx.hue,
        onColorChange: _cache[1] || (_cache[1] = value => _ctx.changeColor(value))
      }, null, 8, ["value", "hue"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", {
          class: "picker-current-color",
          style: { background: _ctx.currentColor }
        }, null, 4),
        _createVNode(_component_Checkboard)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Hue, {
            value: _ctx.color,
            hue: _ctx.hue,
            onColorChange: _cache[2] || (_cache[2] = value => _ctx.changeColor(value))
          }, null, 8, ["value", "hue"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Alpha, {
            value: _ctx.color,
            onColorChange: _cache[3] || (_cache[3] = value => _ctx.changeColor(value))
          }, null, 8, ["value"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_EditableInput, {
        value: _ctx.color,
        onColorChange: _cache[4] || (_cache[4] = value => _ctx.changeColor(value))
      }, null, 8, ["value"])
    ]),
    _createVNode("div", _hoisted_9, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.themeColors, (c) => {
        return (_openBlock(), _createBlock("div", {
          class: "picker-presets-color",
          key: c,
          style: {background: c},
          onClick: ($event: any) => (_ctx.selectPresetColor(c))
        }, null, 12, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_10, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.presetColors, (col, index) => {
        return (_openBlock(), _createBlock("div", {
          class: "picker-gradient-col",
          key: index
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(col, (c) => {
            return (_openBlock(), _createBlock("div", {
              class: "picker-gradient-color",
              key: c,
              style: {background: c},
              onClick: ($event: any) => (_ctx.selectPresetColor(c))
            }, null, 12, ["onClick"]))
          }), 128))
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_11, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.standardColors, (c) => {
        return (_openBlock(), _createBlock("div", {
          key: c,
          class: "picker-presets-color",
          style: { background: c },
          onClick: ($event: any) => (_ctx.selectPresetColor(c))
        }, null, 12, ["onClick"]))
      }), 128))
    ]),
    (_ctx.recentColors.length)
      ? (_openBlock(), _createBlock("div", _hoisted_12, "最近使用："))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_13, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recentColors, (c) => {
        return (_openBlock(), _createBlock("div", {
          key: c,
          class: "picker-presets-color",
          style: { background: c },
          onClick: ($event: any) => (_ctx.selectPresetColor(c))
        }, null, 12, ["onClick"]))
      }), 128))
    ])
  ]))
})